export default "__VITE_ASSET__f239e334__"